import { useAppKitAccount, useAppKitNetwork } from "@reown/appkit/react";
import axios from "axios";
import { BigNumber } from "bignumber.js";
import { ethers } from "ethers";
import React, { useContext, useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import {
  RiArrowDownLine,
  RiArrowUpLine,
  RiExchangeDollarLine,
  RiExternalLinkLine,
  RiFileCopy2Line,
  RiTimer2Line,
  RiWalletLine,
} from "react-icons/ri";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { ClipboardCopy } from "../components/ClipboarCopy";
import { Footer, Header, LoadingWrapper } from "../components/opencoin-ui";
import { useFirestore, useRefCode } from "../hooks/useFirestore";
import {
  useCheckIsNeedApprove,
  useCheckTokenPrice,
  useDynamicCallFunction,
  useDynamicSendFunction,
  useGetERC20Detail,
} from "../hooks/web3hook";
import { getAppByChainId } from "../libs/Env";
import { copyToClipboard, parseFromWei } from "../libs/utils";
import { amountFormat, amountFormatAdd, truncate } from "../libs/WebooLib";
import { Context } from "../Store";
const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";
export default function Home() {
  const { chainId } = useAppKitNetwork();
  const { address, isConnected } = useAppKitAccount();
  const [
    { tokenSymbol, tokenBalance, tokenDecimal, isLoadingTokenInfo },
    fetchTokenInfo,
  ] = useGetERC20Detail();
  const [
    {
      tokenSymbol: tokenSymbolStake,
      tokenBalance: tokenBalanceStake,
      isLoadingTokenInfo: isLoadingTokenInfoStake,
    },
    fetchTokenInfoStake,
  ] = useGetERC20Detail();
  const [
    {
      tokenSymbol: tokenSymbolStake3,
      tokenBalance: tokenBalanceStake3,
      isLoadingTokenInfo: isLoadingTokenInfoStake2,
    },
    fetchTokenInfoStake3,
  ] = useGetERC20Detail();
  const [state, dispatch] = useContext(Context);
  const { app, db, refCode, isLoading } = useRefCode();
  const [totalReferrer, setTotalReferrer] = useState(0);
  const [totalReferrer2, setTotalReferrer2] = useState(0);
  const [totalReferrer3, setTotalReferrer3] = useState(0);
  const [percentDenominator, setPercentDenominator] = useState(0);
  const [percentForReferral, setPercentForReferral] = useState(0);
  const [minimumStakeInDollars, setMinimumStakeInDollars] = useState(0);
  const [minimumStakeInToken, setMinimumStakeInToken] = useState(0);
  const [amountStake, setAmountStake] = useState(0);
  const [totalAllBalanceStake, setTotalAllBalanceStake] = useState(0);
  const [totalPeriod2, setTotalPeriod2] = useState(0);
  const [totalPeriod3, setTotalPeriod3] = useState(0);
  const [isValidAmountStake, setIsValidAmountStake] = useState(false);
  const [availableReward, setAvailableReward] = useState(0);
  const [availableReward2, setAvailableReward2] = useState(0);
  const [availableReward3, setAvailableReward3] = useState(0);
  const [amountStakeInDollar, setAmountStakeInDollar] = useState(0);
  const [availableRewardFromReferral, setAvailableRewardFromReferral] =
    useState(0);
  const [availableRewardFromReferral2, setAvailableRewardFromReferral2] =
    useState(0);
  const [availableRewardFromReferral3, setAvailableRewardFromReferral3] =
    useState(0);
  const [claimedReward, setClaimedReward] = useState(0);
  const [claimedReward2, setClaimedReward2] = useState(0);
  const [claimedReward3, setClaimedReward3] = useState(0);
  const [claimedRewardFromReferral, setClaimedRewardFromReferral] = useState(0);
  const [claimedRewardFromReferral2, setClaimedRewardFromReferral2] =
    useState(0);
  const [claimedRewardFromReferral3, setClaimedRewardFromReferral3] =
    useState(0);
  const [{ isLoading: isLoadingDynamicCall }, dynamicCall] =
    useDynamicCallFunction();
  const [{ result: resultSend, isLoading: isLoadingSend }, dynamicSend] =
    useDynamicSendFunction();
  const [
    { amountAllowance, isNeedApprove, isLoadingCheck, txHashApprove },
    fetchCheck,
    fecthApprove,
  ] = useCheckIsNeedApprove();
  const [{ tokenPrice, isLoadingPrice }, { getPriceInBUSD, getPriceInBNB }] =
    useCheckTokenPrice();
  const [parentReferralAddress, setParentReferralAddress] = useState("");
  const [parentReferralAddress2, setParentReferralAddress2] = useState("");
  const [usdtDecimal, setUsdtDecimal] = useState(18);
  const [totalSupply, setTotalSupply] = useState(0);

  const { putData, getRow } = useFirestore();
  const searchParams = new URLSearchParams(document.location.search);
  const [priceUSD, setPriceUSD] = useState(0);
  const [priceUSDChange, setPriceUSDChange] = useState(0);
  const [volumeUSD24h, setVolumeUSD24h] = useState(0);
  const [stakeInfoPeriod, setStakeInfoPeriod] = useState([]);
  const [stakeInfoPeriod3, setStakeInfoPeriod3] = useState([]);
  const [estStakeInDollars, setEstStakeInDollars] = useState("0");
  const [estStakeInDollars3, setEstStakeInDollars3] = useState("0");
  const { t } = useTranslation();

  const initialize = () => {
    getParentReferral();
    fetchTokenInfo(getAppByChainId(chainId).TOKEN_ADDRESS).then();
    fetchTokenInfoStake(getAppByChainId(chainId).STAKING_ADDRESS_V2).then();
    fetchTokenInfoStake3(getAppByChainId(chainId).STAKING_ADDRESS_V3).then();
    fetchCheck(
      getAppByChainId(chainId).TOKEN_ADDRESS,
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
    ).then();
    getTotalReferrer();
    getMinimumStakeInDollars();
    getMinimumStakeInToken();
    getTotalSupply();
    getTotalPeriod();
    getAvailableReward();
    getAvailableRewardFromReferral();
    getClaimedReward();
    getClaimedRewardFromReferral();
    getPercentReferral();
    fetchTokenData().then();
    getPriceInBUSD(getAppByChainId(chainId).TOKEN_ADDRESS).then();
    getAccumulateStakeInDollars().then();
  };

  const getParentReferral = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "getDirectSponsorOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      setParentReferralAddress(res);
      // console.log("Result Parent Referral: ", res);
      if (!res || res === ADDRESS_ZERO) {
        const _refCode = searchParams.get("ref");
        getRow("Referals", [["refCode", "==", _refCode]]).then((res) => {
          // console.log("Result Referrals from get row: ", res);
          setParentReferralAddress(res[0]?.address);
        });
      }
    });
  };

  const getTotalReferrer = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "totalReferrer",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Total Referral: ", res);
      // console.log(
      //   "Total Referral Which Address: ",
      //   ethers.utils.getAddress(address)
      // );
      setTotalReferrer3(res.toString());
    });

    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V2,
      getAppByChainId(chainId).STAKING_ABI,
      "totalReferrer",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Total Referral: ", res);
      // console.log(
      //   "Total Referral Which Address: ",
      //   ethers.utils.getAddress(address)
      // );
      setTotalReferrer2(res.toString());
    });
  };

  const getMinimumStakeInDollars = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "minimumStakeInDollars",
      [],
    ).then((res) => {
      // console.log("Minimum Stake In Dollars: ", res);
      setMinimumStakeInDollars(res.toString());
    });

    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "usdtAddress",
      [],
    ).then((res) => {
      // console.log("USDT ADDRESS: ", res);
      dynamicCall(res, getAppByChainId(chainId).ERC20_ABI, "decimals", []).then(
        (res2) => {
          // console.log("USDT ADDRESS DECIMALS: ", res2);
          // console.log(res2);
          setUsdtDecimal(res2);
        },
      );
    });
  };

  const getTotalSupply = () => {
    dynamicCall(
      getAppByChainId(chainId).TOKEN_ADDRESS,
      getAppByChainId(chainId).ERC20_ABI,
      "totalSupply",
      [],
    ).then((res) => {
      const res2 = res / 1000000000000000000;
      setTotalSupply(res2);
    });
  };

  const getMinimumStakeInToken = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "getMinimumStakeAmount",
      [],
    ).then((res) => {
      // console.log("Minimum Stake In Token: ", res);
      const _res = new BigNumber(res._hex);
      const _one = new BigNumber(1);
      const _newRes = _res.plus(_res.multipliedBy(0.01));
      // console.log(_newRes);
      setMinimumStakeInToken(_newRes);
    });
  };

  const getTotalPeriod = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "getTotalPeriodOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Total Period Stake: ", res);
      setTotalPeriod3(res.toString());
    });
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V2,
      getAppByChainId(chainId).STAKING_ABI,
      "getTotalPeriodOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Total Period Stake: ", res);
      setTotalPeriod2(res.toString());
    });
  };

  const getStakeInfo2 = async (period) => {
    const data = await dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V2,
      getAppByChainId(chainId).STAKING_ABI,
      "stakePeriods",
      [ethers.utils.getAddress(address), period],
    );
    return data;
  };

  const getStakeInfo3 = async (period) => {
    const data = await dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "stakePeriods",
      [ethers.utils.getAddress(address), period],
    );
    return data;
  };

  const getAccumulateStakeInDollars = async () => {
    let tmp = [];
    let state = true;
    let period = 0;
    while (state) {
      const resp = await getStakeInfo2(period);
      // console.log("Response 0: ", resp["0"].toString());
      if (resp["0"].toString() === "0") {
        state = false;
      } else {
        tmp.push(resp);
        period++;
      }
    }
    setStakeInfoPeriod(tmp);

    let tmp3 = [];
    let state3 = true;
    let period3 = 0;
    while (state3) {
      const resp = await getStakeInfo3(period);
      // console.log("Response 0: ", resp["0"].toString());
      if (resp["0"].toString() === "0") {
        state3 = false;
      } else {
        tmp3.push(resp);
        period++;
      }
    }
    setStakeInfoPeriod3(tmp3);
  };

  const getAvailableReward = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "dividendOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Available Reward: ", res);
      setAvailableReward3(res.toString());
    });

    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V2,
      getAppByChainId(chainId).STAKING_ABI,
      "dividendOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Available Reward: ", res);
      setAvailableReward2(res.toString());
    });
  };

  const getAvailableRewardFromReferral = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "dividendOfReferrer",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Available Reward From Refferal: ", res);
      setAvailableRewardFromReferral2(res.toString());
    });
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V2,
      getAppByChainId(chainId).STAKING_ABI,
      "dividendOfReferrer",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Available Reward From Refferal: ", res);
      setAvailableRewardFromReferral3(res.toString());
    });
  };

  const getClaimedReward = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "getTotalClaimedOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Claimed Reward: ", res);
      setClaimedReward3(res.toString());
    });
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V2,
      getAppByChainId(chainId).STAKING_ABI,
      "getTotalClaimedOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Claimed Reward: ", res);
      setClaimedReward2(res.toString());
    });
  };

  const getPercentReferral = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "percentForReferrer",
      [],
    ).then((res) => {
      // console.log("Percent Referral: ", res);
      setPercentForReferral(res.toString());
    });

    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "percentTaxDenominator",
      [],
    ).then((res) => {
      // console.log("Percent Denominator: ", res);
      setPercentDenominator(res.toString());
    });
  };

  const getClaimedRewardFromReferral = () => {
    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V2,
      getAppByChainId(chainId).STAKING_ABI,
      "getTotalClaimedReferrerOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Claimed Reward From Referral: ", res.toString());
      setClaimedRewardFromReferral2(res.toString());
    });

    dynamicCall(
      getAppByChainId(chainId).STAKING_ADDRESS_V3,
      getAppByChainId(chainId).STAKING_ABI,
      "getTotalClaimedReferrerOf",
      [ethers.utils.getAddress(address)],
    ).then((res) => {
      // console.log("Claimed Reward From Referral: ", res.toString());
      setClaimedRewardFromReferral3(res.toString());
    });
  };

  const handleOnStakeAll = () => {
    const balance = new BigNumber(tokenBalance);
    const _newBalance = balance.minus(0.001);
    setAmountStake(_newBalance.toFixed(8).toString());
  };

  const checkIsValidAmountStake = () => {
    const balance = new BigNumber(parseFromWei(minimumStakeInToken));
    const amount = new BigNumber(amountStake);
    setIsValidAmountStake(amount.isGreaterThanOrEqualTo(balance));
  };

  const handleOnStakeHalf = () => {
    const balance = new BigNumber(tokenBalance);
    const half = balance.dividedBy(2);

    setAmountStake(half.toFixed(8).toString());
  };

  const handleOnMin = () => {
    setAmountStake(parseFromWei(minimumStakeInToken));
  };

  const handleOnSubmit = async () => {
    if (isNeedApprove) {
      fecthApprove(
        getAppByChainId(chainId).TOKEN_ADDRESS,
        getAppByChainId(chainId).STAKING_ADDRESS_V3,
      ).then();
    } else {
      dynamicSend(
        getAppByChainId(chainId).STAKING_ADDRESS_V3,
        getAppByChainId(chainId).STAKING_ABI,
        "stake",
        [
          ethers.utils.parseUnits(amountStake, tokenDecimal),
          ethers.utils.getAddress(parentReferralAddress || ADDRESS_ZERO),
        ],
        ethers.utils.parseUnits(amountStake, tokenDecimal),
        tokenSymbol,
      ).then((res) => {
        initialize();
        toast.success("Stake Success");
        // store data for referrer
        const _amountStake = new BigNumber(
          ethers.utils.parseUnits(amountStake, tokenDecimal),
        );
        const _reward = _amountStake
          .multipliedBy(percentForReferral)
          .dividedBy(percentDenominator);
        putData("ReferalChilds", res.txHash, {
          hash: res.txHash,
          directSponsor: parentReferralAddress || ADDRESS_ZERO,
          address: ethers.utils.getAddress(address),
          amountStake: amountStake.toString(),
          amountReward: _reward.toFixed().toString(),
          amountSymbol: tokenSymbol,
        });
      });
    }
  };

  const handleOnSubmitClaimReward = async () => {
    if (parseFloat(availableReward2.toString()) > 0) {
      dynamicSend(
        getAppByChainId(chainId).STAKING_ADDRESS_V2,
        getAppByChainId(chainId).STAKING_ABI,
        "claimDividend",
        [],
        availableReward2.toString(),
        tokenSymbol,
      ).then((res) => {
        initialize();
      });
    }

    if (parseFloat(availableReward3.toString()) > 0) {
      dynamicSend(
        getAppByChainId(chainId).STAKING_ADDRESS_V3,
        getAppByChainId(chainId).STAKING_ABI,
        "claimDividend",
        [],
        availableReward3.toString(),
        tokenSymbol,
      ).then((res) => {
        initialize();
      });
    }
  };

  const handleOnSubmitClaimRewardReferral = async () => {
    if (parseFloat(availableRewardFromReferral2.toString()) > 0) {
      dynamicSend(
        getAppByChainId(chainId).STAKING_ADDRESS_V2,
        getAppByChainId(chainId).STAKING_ABI,
        "claimDividendReferrer",
        [],
        availableRewardFromReferral2.toString(),
        tokenSymbol,
      ).then((res) => {
        initialize();
      });
    }

    if (parseFloat(availableRewardFromReferral3.toString()) > 0) {
      dynamicSend(
        getAppByChainId(chainId).STAKING_ADDRESS_V3,
        getAppByChainId(chainId).STAKING_ABI,
        "claimDividendReferrer",
        [],
        availableRewardFromReferral3.toString(),
        tokenSymbol,
      ).then((res) => {
        initialize();
      });
    }
  };

  useEffect(() => {
    if (isConnected && address) {
      console.log("initialize called");
      initialize();
    }
  }, [isConnected, address]);

  useEffect(() => {
    if (amountStake === 0) return;
    checkIsValidAmountStake();
  }, [amountStake]);

  useEffect(() => {
    // getTotalStakeInDollars();
  }, [tokenBalanceStake]);

  useEffect(() => {
    let amount_ = new BigNumber(0);
    for (let i = 0; i < stakeInfoPeriod.length; i++) {
      const row = stakeInfoPeriod[i];
      // Pastikan row[4] (amountInDollar) ada dan valid
      if (row[4] && row[4]._hex) {
        // Konversi hex string ke BigNumber
        const amountInDollar = new BigNumber(row[4]._hex);
        // Konversi ke format dengan 18 desimal
        const convertedAmount = amountInDollar.dividedBy(
          new BigNumber(10).pow(18),
        );
        amount_ = amount_.plus(convertedAmount);
      }
    }
    setEstStakeInDollars(amount_.toString());

    let amount3_ = new BigNumber(0);
    for (let i = 0; i < stakeInfoPeriod3.length; i++) {
      const row = stakeInfoPeriod3[i];
      // Pastikan row[4] (amountInDollar) ada dan valid
      if (row[4] && row[4]._hex) {
        // Konversi hex string ke BigNumber
        const amountInDollar = new BigNumber(row[4]._hex);
        // Konversi ke format dengan 18 desimal
        const convertedAmount = amountInDollar.dividedBy(
          new BigNumber(10).pow(18),
        );
        amount3_ = amount3_.plus(convertedAmount);
      }
    }
    setEstStakeInDollars3(amount3_.toString());
  }, [stakeInfoPeriod, stakeInfoPeriod3]);

  const getTotalStakeInDollars = () => {
    if (tokenBalanceStake === 0 || !tokenBalanceStake) return;
    const amountIn = ethers.utils.parseUnits(tokenBalanceStake, tokenDecimal);

    const path = [
      getAppByChainId(chainId).TOKEN_ADDRESS,
      getAppByChainId(chainId).USDT_ADDRESS,
    ];
    dynamicCall(
      getAppByChainId(chainId).ROUTER_ADDRESS,
      getAppByChainId(chainId).PANCAKE_ROUTER_ABI,
      "getAmountsOut",
      [amountIn, path],
    ).then((res) => {
      // console.log(path);
      // console.log(getAppByChainId(chainId).ROUTER_ADDRESS);
      // console.log(amountIn);
      // console.log("Total Stake In Dollars: ", res);
      setAmountStakeInDollar(ethers.utils.formatUnits(res[1], tokenDecimal));
    });
    return 0;
  };

  const fetchTokenData = async () => {
    try {
      const response = await axios.get(
        "https://api.geckoterminal.com/api/v2/networks/bsc/tokens/0x1F19c26a7F9b7A673348258d2fef0B7dF1Edef32/pools?page=1",
      );
      setPriceUSD(response.data?.data[0]?.attributes?.token_price_usd);
      setPriceUSDChange(
        response.data?.data[0]?.attributes?.price_change_percentage?.h24,
      );
      setVolumeUSD24h(response.data.data[0]?.attributes?.volume_usd?.h24);
    } catch (error) {
      console.error("Error fetching token data:", error);
    }
  };

  useEffect(() => {
    setTotalAllBalanceStake(
      parseFloat(tokenBalanceStake) + parseFloat(tokenBalanceStake3),
    );
  }, [tokenBalanceStake, tokenBalanceStake3]);

  return (
    <>
      <Header />
      <section className="relative px-4 py-4 overflow-hidden bg-white md:px-12 lg:px-28 dark:bg-grayc-950 md:py-20 lg:py-20 font-body">
        <div className="w-full p-6 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
          <div className="flex flex-col items-center justify-between w-full lg:flex-row md:flex-col xl:flex-row">
            <div className="flex flex-col items-center gap-8 xl:flex-row lg:flex-row md:flex-row">
              <div className="flex items-center gap-3">
                <img
                  src="/images/icon-reward/opc-coin.png"
                  width="60px"
                  height="60px"
                  alt="opencoin"
                />
                <div className="space-y-1">
                  <h1 className="text-lg font-semibold">
                    Open Coin <span>(OPC)</span>
                  </h1>
                  <div className="flex items-center gap-3">
                    ${Number(priceUSD).toFixed(2)}{" "}
                    <span
                      className={`flex items-center gap-1 ${
                        priceUSDChange < 0
                          ? "text-red-500"
                          : priceUSDChange === 0
                            ? "text-gray-500"
                            : "text-green-500"
                      }`}
                    >
                      {priceUSDChange < 0 ? (
                        <RiArrowDownLine />
                      ) : (
                        <RiArrowUpLine />
                      )}{" "}
                      {priceUSDChange}%
                    </span>
                  </div>
                </div>
              </div>
              <div className="space-y-1">
                <h1 className="text-lg font-semibold">{t("market cap")}</h1>
                <div className="flex items-center gap-3">
                  ${Number(totalSupply * priceUSD).toFixed(2)}
                </div>
              </div>
              <div className="space-y-1">
                <h1 className="text-lg font-semibold">{t("24h volume")}</h1>
                <div className="flex items-center gap-1">
                  <img
                    src="/images/icon-reward/opc-coin.png"
                    width="25px"
                    height="25px"
                    alt="opencoin"
                  />{" "}
                  ${Number(volumeUSD24h).toFixed(2)}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4 mt-6 xl:mt-0 lg:mt-0 md:mt-6">
              <a
                href={`https://bscscan.com/token/${
                  getAppByChainId(chainId).TOKEN_ADDRESS
                }}`}
                target="_blank"
                rel="noreferrer"
                className="px-6 py-4 font-semibold text-center text-white rounded-xl bg-grayc-900 dark:bg-grayc-950 hover:bg-grayc-900 dark:hover:bg-yellowc-500 dark:hover:text-gray-900"
              >
                {t("token contract")}
              </a>
              <a
                href="https://www.okx.com/web3/dex-swap?inputChain=56&inputCurrency=0x55d398326f99059ff775485246999027b3197955&outputChain=56&outputCurrency=0x1f19c26a7f9b7a673348258d2fef0b7df1edef32"
                target="_blank"
                rel="noreferrer"
                className="px-6 py-4 font-semibold text-center text-gray-900 bg-white rounded-xl hover:bg-gray-200 dark:hover:bg-grayc-950 dark:hover:text-white"
              >
                {t("buy opencoin")}
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between w-full gap-10 mt-12 md:flex-row lg:flex-row xl:flex-row">
          <div className="w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
            <div className="w-full p-6 xl:space-y-2.5 lg:space-y-2.5 md:space-y-3 space-y-4 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                <div>{t("your opencoin balance")}</div>
                <div className="flex items-center gap-1 text-end">
                  <img
                    src="/images/icon-reward/opc-coin.png"
                    height="25px"
                    width="25px"
                    alt="opencoin-small"
                  />
                  <LoadingWrapper
                    isLoading={isLoadingTokenInfo}
                    children={
                      <div>
                        {amountFormat(tokenBalance)} {tokenSymbol}
                      </div>
                    }
                  />
                </div>
              </div>

              <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                <div>{t("your referral count")}</div>
                <div className="flex items-center gap-1 text-end">
                  <LoadingWrapper
                    isLoading={isLoadingDynamicCall}
                    children={<div>{totalReferrer2}</div>}
                  />
                </div>
              </div>
              <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                <div>{t("your period count")}</div>
                <div className="flex items-center gap-1 text-end">
                  <LoadingWrapper
                    isLoading={isLoadingDynamicCall}
                    children={<div>{totalPeriod2}</div>}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
            <div className="w-full p-6 space-y-2 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <div className="flex items-center justify-between">
                <div>{t("opencoin address")}</div>
                <div className="flex items-center gap-1 text-end">
                  <div className="flex items-center gap-2 px-4 py-2 font-bold bg-white border border-[#e3e3e4] dark:border-grayc-700 dark:bg-grayc-900 rounded-md">
                    <img
                      src="/images/icon-reward/bnb.svg"
                      width="15px"
                      height="15px"
                      alt="bsc"
                    />
                    <>
                      <a
                        href={`https://bscscan.com/token/${
                          getAppByChainId(chainId).TOKEN_ADDRESS
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="opencoin"
                        className="flex items-center gap-1 text-yellowc-700 dark:hover:text-yellowc-500 hover:text-yellowc-500"
                      >
                        {truncate(
                          getAppByChainId(chainId).TOKEN_ADDRESS,
                          4,
                          "...",
                          50,
                        )}
                        <RiExternalLinkLine />
                      </a>
                      <ClipboardCopy
                        copyText={getAppByChainId(chainId).TOKEN_ADDRESS}
                      />
                    </>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div>{t("stake address")}</div>
                <div className="flex items-center gap-1 text-end">
                  <div className="flex items-center gap-2 px-4 py-2 font-bold bg-white border border-[#e3e3e4] dark:border-grayc-700 dark:bg-grayc-900 rounded-md">
                    <img
                      src="/images/icon-reward/bnb.svg"
                      width="15px"
                      height="15px"
                      alt="bsc"
                    />
                    <>
                      <a
                        href={`https://bscscan.com/token/${
                          getAppByChainId(chainId).STAKING_ADDRESS_V3
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="opencoin"
                        className="flex items-center gap-1 text-yellowc-700 dark:hover:text-yellowc-500 hover:text-yellowc-500"
                      >
                        {truncate(
                          getAppByChainId(chainId).STAKING_ADDRESS_V3,
                          4,
                          "...",
                          50,
                        )}
                        <RiExternalLinkLine />
                      </a>
                      <ClipboardCopy
                        copyText={truncate(
                          getAppByChainId(chainId).STAKING_ADDRESS_V3,
                        )}
                      />
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between w-full gap-10 mt-12 md:flex-row lg:flex-row xl:flex-row">
          <div className="w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
            <div className="w-full p-6 space-y-3 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <div className="flex items-center justify-between w-full">
                <a
                  href="https://www.okx.com/web3/dex-swap?inputChain=56&inputCurrency=0x55d398326f99059ff775485246999027b3197955&outputChain=56&outputCurrency=0x1f19c26a7f9b7a673348258d2fef0b7df1edef32"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 text-black dark:text-white hover:text-yellowc-600 dark:hover:text-yellowc-500"
                >
                  <RiExchangeDollarLine />
                  <div className="font-semibold">{t("get opencoin")}</div>
                </a>
                <a
                  href="/#"
                  className="flex items-center gap-1 text-black dark:text-white hover:text-yellowc-600 dark:hover:text-yellowc-500"
                >
                  <RiTimer2Line />
                  <div className="font-semibold">{t("history")}</div>
                </a>
              </div>

              <div className="p-4 bg-white dark:bg-grayc-800 rounded-2xl">
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center gap-3">
                    <button
                      type={"button"}
                      onClick={() => handleOnStakeAll()}
                      className="px-6 py-1 text-sm text-gray-800 bg-gray-100 dark:bg-grayc-900 dark:text-grayc-100 border-grayc-400 dark:border-gray-900 hover:border-gray-700 dark:hover:border-grayc-500 rounded-xl"
                    >
                      {t("max")}
                    </button>
                    <button
                      type={"button"}
                      onClick={() => handleOnStakeHalf()}
                      className="px-6 py-1 text-sm text-gray-800 bg-gray-100 dark:bg-grayc-900 dark:text-grayc-100 border-grayc-400 dark:border-gray-900 hover:border-gray-700 dark:hover:border-grayc-500 rounded-xl"
                    >
                      {t("half")}
                    </button>
                    <button
                      type={"button"}
                      onClick={() => handleOnMin()}
                      className="px-6 py-1 text-sm text-gray-800 bg-gray-100 dark:bg-grayc-900 dark:text-grayc-100 border-grayc-400 dark:border-gray-900 hover:border-gray-700 dark:hover:border-grayc-500 rounded-xl"
                    >
                      {t("min")}
                    </button>
                  </div>

                  <div className="flex items-center gap-2">
                    <RiWalletLine />
                    <div>
                      {amountFormat(tokenBalance)} {tokenSymbol}
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between w-full gap-4 my-4">
                  <CurrencyInput
                    className="w-8/12 gap-2 px-4 py-2 bg-gray-100 xl:w-10/12 lg:w-10/12 md:w-8/12 border-grayc-600 dark:border-grayc-900 dark:bg-grayc-900 rounded-xl"
                    placeholder="0"
                    value={amountStake}
                    onValueChange={(value) => {
                      setAmountStake(value);
                    }}
                  />
                  <div className="flex items-center w-4/12 gap-1 px-4 py-2 bg-gray-100 md:w-4/12 lg:w-2/12 xl:w-2/12 border-grayc-600 dark:border-gracy-900 dark:bg-grayc-900 rounded-xl">
                    <img
                      src="/images/icon-reward/opc-coin.png"
                      width="25px"
                      height="25px"
                      alt="opencoin-sm"
                    />
                    <div>OPC</div>
                  </div>
                </div>
                <div>
                  {isValidAmountStake === false && (
                    <small className={"text-red-800"}>
                      {t("invalid amount")}
                    </small>
                  )}
                </div>
                <div>
                  {t("minimum stake")}:{" "}
                  {parseFromWei(minimumStakeInDollars, usdtDecimal, 6)} USDT ={" "}
                  {amountFormat(parseFromWei(minimumStakeInToken))}{" "}
                  {tokenSymbol}
                </div>
              </div>

              <div className="flex items-center justify-between w-full gap-4 pt-3">
                <button
                  type={"button"}
                  className={
                    "w-full flex items-center justify-center gap-2 px-6 py-3 text-center text-white rounded-3xl " +
                    (isValidAmountStake
                      ? "bg-grayc-950 hover:bg-yellowc-500 hover:text-gray-900"
                      : "bg-gray-400 text-gray-800")
                  }
                  disabled={isValidAmountStake === false}
                  // disabled
                  onClick={handleOnSubmit}
                >
                  {isNeedApprove ? t("approve") : t("stake")}
                  <div className={""}>
                    <ClipLoader
                      color={"#f59e0b"}
                      loading={isLoadingCheck || isLoadingSend}
                      size={20}
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
            <div className="w-full p-6 space-y-3 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <h1 className="mb-5 text-lg font-semibold">
                {t("stake information")}
              </h1>
              <div className="space-y-3">
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("stake amount")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <img
                      src="/images/icon-reward/opc-coin.png"
                      height="25px"
                      width="25px"
                      alt="opencoin-small"
                    />
                    <LoadingWrapper
                      isLoading={isLoadingTokenInfoStake}
                      children={
                        <div>
                          {amountFormat(totalAllBalanceStake)}{" "}
                          {tokenSymbolStake} (est{" "}
                          {amountFormat(
                            parseFloat(estStakeInDollars) +
                              parseFloat(estStakeInDollars3),
                            2,
                          )}{" "}
                          USDT)
                        </div>
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("available reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <img
                      src="/images/icon-reward/opc-coin.png"
                      height="25px"
                      width="25px"
                      alt="opencoin-small"
                    />
                    <LoadingWrapper
                      isLoading={
                        isLoadingTokenInfoStake || isLoadingDynamicCall
                      }
                      children={
                        <div>
                          {amountFormatAdd(
                            parseFromWei(availableReward),
                            parseFromWei(availableReward2),
                            parseFromWei(availableReward3),
                          )}{" "}
                          {tokenSymbol} ($
                          {Number(
                            amountFormatAdd(
                              parseFromWei(availableReward),
                              parseFromWei(availableReward2),
                              parseFromWei(availableReward3),
                            ) * priceUSD,
                          )}
                          )
                        </div>
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("claimed reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <img
                      src="/images/icon-reward/opc-coin.png"
                      height="25px"
                      width="25px"
                      alt="opencoin-small"
                    />
                    <LoadingWrapper
                      isLoading={
                        isLoadingTokenInfoStake || isLoadingDynamicCall
                      }
                      children={
                        <div>
                          {amountFormatAdd(
                            parseFromWei(claimedReward),
                            parseFromWei(claimedReward2),
                            parseFromWei(claimedReward3),
                          )}{" "}
                          {tokenSymbol} ($
                          {Number(
                            amountFormatAdd(
                              parseFromWei(claimedReward),
                              parseFromWei(claimedReward2),
                              parseFromWei(claimedReward3),
                            ) * priceUSD,
                          )}
                          )
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="flex gap-4 pt-3">
                <button
                  type={"button"}
                  // this bugs
                  // disabled
                  className="flex items-center gap-2 px-8 py-3 text-gray-900 bg-yellowc-500 hover:bg-yellowc-600 rounded-xl"
                  onClick={handleOnSubmitClaimReward}
                >
                  <div>{t("claim reward")}</div>
                  <div className={""}>
                    <ClipLoader
                      color={"#f59e0b"}
                      loading={isLoadingCheck || isLoadingSend}
                      size={20}
                    />
                  </div>
                </button>
              </div>
            </div>

            <div className="w-full p-6 mt-12 space-y-3 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <h1 className="mb-5 text-lg font-semibold">
                {t("referral information")}
              </h1>
              <div className="space-y-3" key={"refCode-" + refCode}>
                <div className="flex items-center justify-start w-full">
                  <div className="px-6 py-3 font-semibold text-black bg-yellowc-500 rounded-l-md whitespace-nowrap">
                    {t("referral link")}
                  </div>
                  <input
                    type="text"
                    className="w-full px-6 py-3 text-black bg-white dark:bg-grayc-950 dark:text-white"
                    placeholder={
                      window.location.origin + "/staking?ref=" + refCode
                    }
                    defaultValue={
                      window.location.origin + "/staking?ref=" + refCode
                    }
                  />
                  <button
                    className="flex items-center justify-center px-4 py-4 text-black bg-yellowc-500 hover:bg-yellowc-600 rounded-r-md"
                    type={"button"}
                    onClick={() =>
                      copyToClipboard(
                        toast,
                        window.location.origin + "/staking?ref=" + refCode,
                      )
                    }
                  >
                    <RiFileCopy2Line />
                  </button>
                </div>
                <div></div>
                <div className="flex flex-col items-start justify-between pt-4 xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <div>
                      {(percentForReferral / percentDenominator) * 100} %
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("available reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <img
                      src="/images/icon-reward/opc-coin.png"
                      height="25px"
                      width="25px"
                      alt="opencoin-small"
                    />
                    <div>
                      {amountFormatAdd(
                        parseFromWei(availableRewardFromReferral),
                        parseFromWei(availableRewardFromReferral2),
                      )}{" "}
                      {tokenSymbol}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("claimed reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <img
                      src="/images/icon-reward/opc-coin.png"
                      height="25px"
                      width="25px"
                      alt="opencoin-small"
                    />
                    <div>
                      {amountFormatAdd(
                        parseFromWei(claimedRewardFromReferral),
                        parseFromWei(claimedRewardFromReferral2),
                      )}{" "}
                      {tokenSymbol}
                    </div>
                  </div>
                </div>
                <div className="flex gap-4 pt-3">
                  {/* this bugs */}
                  <button
                    type={"button"}
                    className="flex items-center gap-2 px-8 py-3 text-gray-900 bg-yellowc-500 hover:bg-yellowc-600 rounded-xl"
                    onClick={handleOnSubmitClaimRewardReferral}
                  >
                    <div>{t("claim reward")}</div>
                    <div className={""}>
                      <ClipLoader
                        color={"#f59e0b"}
                        loading={isLoadingCheck || isLoadingSend}
                        size={20}
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
